<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1#P1">I: E<span class="small">ARTH</span> <span class="small">AND</span> S<span class="small">KY</span> G<span class="small">ODS</span></a></p>
<p class="toc"><a href="#/Chapter1#C1">1. Cradles of the Past and Animating Forces</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Chaco Otherworld</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Aztec Journey</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Realm of the Gods</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Salt Woman</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Curse of Deception</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. An Ominous History</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Capitulation of Indians</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">II: C<span class="small">YCLES</span> <span class="small">OF</span> P<span class="small">OWERFUL</span> F<span class="small">ORCES</span></span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Dark Omens</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Indian Resistance</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Ghost Dance</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. The Spirit and the Gun</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Powerful Forces</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Inculcation and Leaving Spirits</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Hope and Resilience</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5d691803